import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(sp.get("token") || "");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success("Password diperbarui. Silakan masuk.");
      nav("/login");
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-hotpot-grid p-4">
      <form onSubmit={submit} className="glass w-full max-w-md rounded-3xl p-8 red-glow">
        <div className="mb-6 flex justify-center"><Brand size={60} showText={false} /></div>
        <h1 className="mb-4 text-center font-display text-2xl font-extrabold text-neutral-900">Reset Password</h1>
        <Input data-testid="reset-token" placeholder="Token reset" value={token} onChange={(e) => setToken(e.target.value)}
          className="touch-btn mb-3 bg-neutral-100 border-neutral-200 text-neutral-900" required />
        <Input data-testid="reset-password" type="password" placeholder="Password baru" value={pwd}
          onChange={(e) => setPwd(e.target.value)} className="touch-btn mb-4 bg-neutral-100 border-neutral-200 text-neutral-900" required />
        <Button data-testid="reset-submit" disabled={busy} className="touch-btn w-full bg-crimson font-bold hover:bg-red-500">
          {busy ? <Loader2 className="animate-spin" /> : "Simpan Password Baru"}
        </Button>
        <button type="button" onClick={() => nav("/login")} className="mt-4 w-full text-center text-xs text-muted-foreground hover:text-neutral-900">
          Kembali ke Login
        </button>
      </form>
    </div>
  );
}
